import { getClientsApi } from "@Shared/@Utils/ajax";
export const getContactData = subdomain => {
  return getClientsApi({
    subdomain
  }, "/account/contacts");
};